<template>
  <v-container>
    <v-row>
      <v-col :cols="12">
        <div class="title-container">
          <div class="font-weight-bold mt-10 title-page">Minha Conta - Editar</div>
          <div class="button-group">
            <v-btn type="button" elevation="0" color="primary" @click="save" :disabled="dataset.loading" :loading="saving">
              Atualizar
            </v-btn>
            <v-btn id="btnBack" type="button" elevation="0" color="primary" outlined
              to="/conta-procurador">Voltar</v-btn>
          </div>
        </div>
      </v-col>
    </v-row>

    <br />
    <br />

    <div class="mt-4" v-if="dataset.loading">
      <v-progress-circular indeterminate color="primary" size="50"></v-progress-circular>
    </div>

    <v-form v-if="!dataset.loading && user" ref="form" v-model="validForm" lazy-validation>
      <v-card class="card-form-outlined">
        <v-card-title class="card-group-title">Dados Pessoais</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field v-model="dataset.data.name" label="Nome Completo" outlined dense required :rules="[$rules.required]"
                hide-details="auto"></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field v-model="dataset.data.phone_number" label="Telefone" outlined dense required
                :rules="[rules.required]" hide-details="auto"></v-text-field>
            </v-col>

          </v-row>

          <v-row>

            <v-col cols="12" md="6">
              <v-text-field v-model="dataset.data.federal_registration" label="OAB" outlined dense required :rules="[$rules.required]"
                hide-details="auto"></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-autocomplete dense id="address_state" label="OAB UF" :items="statesList" item-text="name"
                item-value="sigla" v-model="dataset.data.federal_registration_uf" required :rules="[$rules.required]"
                outlined hide-details="auto">
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card class="card-form-outlined mt-6">
        <v-card-title class="card-group-title">Endereço</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field dense id="address_postal_code" label="CEP" v-model="dataset.data.address_postal_code"
                required :rules="[$rules.required, $rules.cep]" outlined hide-details="auto" v-mask="'##.###-###'"
                @blur="searchCep"></v-text-field>
            </v-col>

            <v-col cols="12" md="8">
              <v-text-field v-model="dataset.data.address_street" label="Rua/Avenida" outlined dense required :rules="[$rules.required]"
                hide-details="auto"></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="4">
              <v-text-field v-model="dataset.data.address_number" label="Número" outlined dense required :rules="[$rules.required]"
                hide-details="auto"></v-text-field>
            </v-col>

            <v-col cols="12" md="8">
              <v-text-field v-model="dataset.data.address_complement" label="Complemento" outlined dense
                hide-details="auto"></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="4">
              <v-text-field v-model="dataset.data.address_neighborhood" label="Bairro" outlined dense required :rules="[$rules.required]"
                hide-details="auto"></v-text-field>
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field v-model="dataset.data.address_city" label="Cidade" outlined dense required :rules="[$rules.required]"
                hide-details="auto"></v-text-field>
            </v-col>

            <v-col cols="12" md="4">
              <v-autocomplete dense id="address_state" label="Estado" :items="statesList" item-text="name"
                item-value="sigla" v-model="dataset.data.address_state" required :rules="[$rules.required]" outlined
                hide-details="auto">
              </v-autocomplete>
            </v-col>

          </v-row>
        </v-card-text>
      </v-card>
    </v-form>

    <v-row v-if="user">
      <v-col cols="12">
        <v-card class="card-form-outlined" color="gray">
          <v-card-title class="card-group-title">
            <div class="title-container">
              <div class="title-block">
                <span id="title" class="table-card-title">Ações</span>
              </div>
            </div>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="3">
                <v-row>
                  <v-col cols="12">
                    <v-btn type="button" elevation="0" color="primary" outlined :href="dataset.data.documentUrl"
                      target="_blank" block>
                      Visualizar documento
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row class="mt-3">
                  <v-col cols="12">
                    <v-file-input dense accept="image/png, image/jpeg, application/pdf" prepend-icon="" outlined counter
                      required show-size :rules="fileRules" hint="Máximo 15MB" hide-details="auto"
                      label="Trocar documento" :clearable="true" @change="onFileSelected($event)"
                      ref="identification_doc" truncate-length="70" />
                  </v-col>
                </v-row>
                <v-row class="mt-n1">
                  <v-col>
                    <iframe :src="dataset.data.documentUrl" width="250" height="150" frameborder="0" scrolling="no"
                      class="rounded-xl"></iframe>

                    <div class="caption-text">DOCUMENTO IDENTIFICAÇÂO</div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import 'moment/locale/pt-br'
import { eventHub } from '@/main'
import statesList from '@/common/data/states-list.data'
import axios from 'axios'
import string from "@/common/util/string";

export default {
  data() {
    return {
      user: null,
      saving: false,
      loading: false,
      validForm: false,
      statesList: statesList,
      
      dataset: {
        loading: false,
        data: {
            name: '',
            phone_number: '',
            federal_registration: '',
            federal_registration_uf: '',
            address_street: '',
            address_number: '',
            address_complement: '',
            address_neighborhood: '',
            address_city: '',
            address_postal_code: '',
            address_state: null, 
        },
      },
      //form: {},

      showCpfCnpjWarning: false,
      showEmailWarning: false,

      rules: {
        required: v => !!v || "Campo obrigatório",
      }
    };
  },

  // mounted() {
  //   this.loadUser();
  // },

  created() {
    if (this.$root.user) {
      this.user = this.$root.user;
      console.log("Dados USER: ", this.user)
      this.loadUser();
    }
  },

  computed: {
    fileRules() {
      const rules = []
      if (!this.dataset.data.documentUrl) {
        rules.push(this.$rules.required)
      }
      rules.push(this.$rules.fileSize(15))
      return rules
    },
  },

  methods: {
    async loadUser() {
      try {
      
        this.dataset.loading = true;

        const result = await axios.get('/api/lawyers/my-account')

        this.dataset.data = result.data.content.data;

      } catch (err) {
        console.error("Erro ao carregar dados do procurador:", err);
      } finally {
        this.dataset.loading = false;
      }
    },

    onFileSelected(file) {
      this.dataset.data.file = file
    },

    async save() {
      const valid = this.$refs.form.validate();
      if (!valid) return;

      const confirm = await this.$dialog.confirm({
        text: 'Deseja salvar as alterações?',
        title: 'Atualizar Informações',
        actions: {
          false: 'Cancelar',
          true: 'Salvar'
        }
      })

      if (!confirm) return

      this.saving = true;

      const payload = this.buildPayload()

      try {
        await axios.patch("/api/lawyers/my-account", payload);

        this.$dialog.notify.success('Dados atualizados com sucesso!', {
          position: 'top-right',
          timeout: 5000
        })

        this.$router.push("/conta-procurador");

      } catch (err) {
        console.error(err);

        if (err.response && err.response.data) {
          const apiMessage =
            err.response.data.message ||
            err.response.data.error ||
            "Ocorreu um erro ao atualizar os dados.";

          this.$dialog.notify.error(apiMessage, {
            position: "top-right",
            timeout: 5000
          });
          return;
        }
      } finally {
        this.saving = false;
      }
    },

    buildPayload() {
      const formData = new FormData()

      formData.append('name', this.dataset.data.name)
      formData.append('phone_number', this.dataset.data.phone_number)
      formData.append('address_street', this.dataset.data.address_street)
      formData.append('address_number', this.dataset.data.address_number)
      formData.append('address_complement', this.dataset.data.address_complement)
      formData.append('address_neighborhood', this.dataset.data.address_neighborhood)
      formData.append('address_city', this.dataset.data.address_city)
      formData.append('address_postal_code', this.dataset.data.address_postal_code)
      formData.append('address_state', this.dataset.data.address_state)
      formData.append('federal_registration', this.dataset.data.federal_registration)
      formData.append('federal_registration_uf', this.dataset.data.federal_registration_uf)

      if (this.dataset.data.file) {
        formData.append('file', this.dataset.data.file)
      }

      return formData
    },

    async searchCep() {

      if ( !this.dataset || !this.dataset.data || !this.dataset.data.address_postal_code ) {
        return;
      }

      const cep = this.dataset.data.address_postal_code.replace(/\D/g, '')
      if (cep.length !== 8) {
        return
      }

      try {
        const response = await axios.get(`https://viacep.com.br/ws/${cep}/json/`)
        const data = response.data

        if (!data.erro) { 
          this.dataset.data.address_street = data.logradouro
          this.dataset.data.address_neighborhood = data.bairro
          this.dataset.data.address_city = data.localidade
          this.dataset.data.address_state = data.uf 
        } else {
          this.dataset.data.address_street = ''
          this.dataset.data.address_neighborhood = ''
          this.dataset.data.address_city = ''
          this.dataset.data.address_state = null
         
        }
      } catch (error) {
        this.dataset.data.address_street = ''
        this.dataset.data.address_neighborhood = ''
        this.dataset.data.address_city = ''
        this.dataset.data.address_state = null
      }
    },
  }
};
</script>

<style scoped>
.title-page {
  font-size: 26px;
}

.title-page {
  color: var(--v-primary-base);
  font-family: 'Raleway';
  font-size: 40px;
  font-style: normal;
  font-weight: 700;
  line-height: 38px;
}

.title-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-form-outlined {
  border: 1px solid #e0e0e0;
}
</style>
